import { useMutation } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';
import { saveDownloadedFile } from '../downloadFile';

interface TransitProps {
  id: string;
}

export const useDownloadTransitFollowLetter = () => {
  return useMutation({
    mutationFn: async ({ id }: TransitProps) => {
      const result = await apiClient.transit.downloadNctsFollowLetter.query({ params: { id } });
      if (result.status !== 200) throw result.body;

      saveDownloadedFile(result.body as Blob, result.headers, 'application/pdf');
    },
    onError: (error) => {
      showErrorToast(error, `Error downloading file!`);
    },
  });
};
